export default {
    newsFiveTitle: 'Menggodok Data, Membangun "Credit Scoring"',
    newsFiveTime: "Tanggal Publis",
    newsFiveRead:"Tampilan Halaman",
    newsFiveSource:"Sumber artikel:",
    newsFiveDetail: [
        {
            p: 'Bagaimana startup teknologi finansial membangun basisdata "credit scoring" pelanggan'
        },
        {
            p: "Marsya Nabila - 4 December 2019"
        },
        {
            p: "Punya rekening bank, tapi saat mengajukan kartu kredit saja selalu ditolak? Di sini kamu masuk ke golongan underbanked. Di bawah underbanked, ada unbanked yang berarti kamu tidak punya rekening bank."
        },
        {
            p: 'Dua golongan di atas selama ini "diasingkan" bank dan layanan jasa keuangan konvensional lainnya, meski memiliki potensi bisnis yang besar. Utilisasi segmen ini rendah dan belum bisa dimanfaatkan 111 bank yang beroperasi di Indonesia karena terlalu berisiko.'
        },
        {
            p: "Menurut laporan termutakhir e-Conomy SEA 2019 yang disusun Google, Temasek, dan Bain & Company, ada 51% penduduk Indonesia yang masuk ke golongan unbanked; underbanked 26%; dan banked 23%."
        },
        {
            h4: "Secara umum, di Asia Tenggara, 75% penduduk di Asia Tenggara masuk kategori underbanked dan unbanked. Mereka ini kurang terlayani (under-served) karena berbagai alasan."
        },
        {
            image:require('@/assets/idImage/newdetail/newfive1.jpg')
        },
        {
            p: 'Dari sisi lembaga keuangan, ada biaya tinggi untuk melayani mereka yang tidak sebanding dengan potensi pendapatan rendah dalam jangka menengah. Alasan lain termasuk riwayat kredit yang terbatas, tingkat tabungan rendah, dan "kesadaran terbatas" dalam hal asuransi atau investasi.'
        },
        {
            p: "Benang merah di sini adalah inklusi. Bagaimana meningkatkan literasi masyarakat yang memilih untuk tidak tergabung dalam sistem perbankan formal untuk masuk ke ekosistem."
        },
        {
            p: "Alasan klasik bank untuk tidak menggarap dua segmen nasabah ini karena ketidaktersediaan data di BI Checking (kini SLIK). Dengan sistem perbankan yang didesain begitu eksklusif, hal ini memaksa bank untuk main aman. Jika laporan keuangan sedikit jelek, mereka langsung ditegur regulator."
        },
        {
            p: 'Bank di Indonesia punya biaya dana (cost of fund) yang tinggi. Hal ini mengakibatkan tingginya bunga yang dibebankan ke nasabah. Margin bunga bersih (net interest margin/NIM) di negara ini tertinggi di Asia Tenggara, ada di level 4,69% pada Agustus 2019 menurut OJK. Bandingkan dengan NIM Singapura yang "hanya" di level 3,62%.'
        },
        {
            p: "Potensi bisnis yang dibiarkan tak diambil begitu lama akhirnya dimanfaatkan para pemain fintech, baik lending maupun payment, yang mulai membuat bank berkeringat dingin."
        },
        {
            image:require('@/assets/idImage/newdetail/newfive2.jpg')
        },
        {
            p: 'Lihat bagaimana perkembangan Akulaku dan Kredivo, dua pemain fintech terbesar di sisi lending yang menawarkan kemudahan"kartu kredit digital". Proses sepenuhnya dilakukan secara online dan dalam hitungan menit nasabah bisa langsung mendapatkan persetujuan.'
        },
        {
            h4: "Lalu GoPay, Ovo, dan Dana yang begitu cepat masuk ke berbagai daerah dengan berbagai variasi produk."
        },
        {
            p: "Yang perlu ditekankan di sini adalah seluruh perusahaan yang disebutkan di atas adalah anak baru dengan lama operasional kurang dari lima tahun. Mereka lebih berani menggarap segmen unbanked dan unbankable ketimbang mereka yang lebih lama malang melintang di industri."
        },
        {
            h4:'Cara bank melakukan credit scoring'
        },
        {
            p: "Cara bank menganalisis nasabah bisa dikatakan cukup konservatif. Pedomannya menggunakan analisis 5C dengan prinsip 5P. 5C meliputi character, capacity, capital, condition, dan collateral. Sementara 5P adalah personality, purpose, prospect, payment, dan party."
        },
        {
            p: "Setiap mengajukan kredit ke bank, apapun jenis produknya, prosesnya mensyaratkan SLIK/Sistem Layanan Informasi Keuangan (dulu bernama BI Checking atau SID (Sistem Informasi Debitur) sebagai penentu kelayakan calon debitur."
        },
        {
            p: "SLIK dapat diakses 24/7 secara online dan offline oleh lembaga keuangan, baik bank dan nonbank, asal terdaftar sebagai anggota Biro Informasi Kredit (disebut Lembaga Pengelola Informasi Perkreditan/LPIP). Di dalam SLIK terdapat informasi debitur dan fasilitas kreditnya yang dipertukarkan ke sesama lembaga keuangan."
        },
        {
            p: "Nasabah punya skor kredit dari catatan kolektabilitasnya, dihitung dari 1 sampai 5. Semakin kecil skornya semakin besar potensi aplikasi terima. Bila masuk skor 3, 4, dan 5 otomatis ia akan ditolak karena masuk ke daftar hitam. Orang yang tidak memiliki riwayat kredit sama sekali termasuk dalam jajaran yang otomatis ditolak."
        },
        {
            p: "Mengingat bank hanya mengambil segmen bankable yang punya riwayat kredit, sumber data yang digunakan lebih banyak mengambil dari data kredit plus data lain untuk memperkuat skoring kredit."
        },
        {
            p: "Beda halnya dengan  startup fintech. Karena nasabahnya belum tentu punya data kredit yang mencukupi, startup fintech akan mengandalkan data lain atau disebut data alternatif untuk menghasilkan skoring kreditnya."
        },
        {
            image:require('@/assets/idImage/newdetail/newfive3.jpg')
        },
        {
            p: '"Maka risk appetite dalam menggunakan credit scoring bisa saja berbeda, apakah lebih risk tolerance atau tidak, dan ini tergantung dari masing-masing kebutuhannya," ujar Direktur Utama Pefindo Biro Kredit Yohanes Arts Abimanyu (7/11).'
        },
        {
            p: "Pertanyaan yang kemudian timbul adalah apakah analisis kredit yang selama ini dipakai bank sepenuhnya berkualitas? Jawabannya bervariasi, tergantung sudut pandang yang dipakai."
        },
        {
            p: "Menurut Co-Founder dan CEO Fineoz Anis Radianis, salah satu layanan solusi risiko kredit berbasis AI, kriteria kualitas primer skor kredit ada tiga macam. Pertama, tingkat akurasi skor kredit dalam memilih calon nasabah yang baik dan buruk. Kedua, model yang dinamis mengikuti perkembangan terbaru, dan skor kredit yang tidak hanya mengurasi risiko tapi mampu memaksimalkan profit."
        },
        {
            p: "Kualitas primer ini sangat penting karena bisa menentukan keberlangsungan hidup lembaga keuangan dalam menjalankan bisnisnya."
        },
        {
            p: "Di Indonesia, sayangnya skor kredit masih mengandalkan dari internal yang secara fundamental punya banyak kelemahan. Misalnya, dalam memilah nasabah yang mampu bayar utang, masih menggunakan pendekatan tradisional statistik yang sangat tidak akurat, tidak dinamis, dan kurang menguntungkan."
        },
        {
            p: "Secara umum, penggunaan data kredit dalam pembuatan skor kredit akan memiliki kualitas yang lebih baik jika dibandingkan dengan pakai data alternatif."
        },
        {
            p: '"Kenapa masih tetap menggunakan pendekatan tradisional? Karena mudah untuk dijelaskan, dan sederhana. Jadi ada beberapa lembaga keuangan yang menganggap kualitas skor kredit mereka sudah baik," terang Anis kepada DailySocial (20/11).'
        },
        {
            p: "Hasil akhir dengan pendekatan ini memang benar-benar bisa mengurangi tingkat risiko gagal bayar. Meskipun demikian, hal ini harus dibayar dengan banyaknya penolakan calon nasabah karena bank lebih memilih main aman."
        },
        {
            p: "Belum lagi kualitas sekunder seperti tingkat kecepatan. Banyak lembaga keuangan yang membutuhkan waktu berhari-hari untuk proses underwriting. Memang sudah ada pemain yang membuat skor kredit dalam hitungan menit, tapi kualitas primer dalam memilah baik atau buruk masih dengan pendekatan lama."
        },
        {
            p: '"Bank bisa pakai model scoring kredit yang dikalibrasi setahun sekali atau dua kali, sebab dalam setahun ada banyak hal-hal baru yang bisa terjadi untuk memaksimalkan profit mereka dengan menggarap calon nasabah yang sebenarnya qualified," tambahnya.'
        },
        {
            p: "Bank memang tidak bisa sedinamis startup fintech, namun tidak menutup kemungkinan untuk berkolaborasi dengan tetap taat ke asas prudent. Hal ini bisa dilihat dengan berbagai kolaborasi dalam penyaluran kredit produktif untuk usaha mikro dan terdaftar sebagai peminjam fintech."
        },
        {
            p: "Strategi tersebut memperlihatkan bank memercayakan cara dan kualitas skor kredit di startup fintech. Mereka ingin memperbesar penyaluran dana kredit, dengan memperkecil risiko gagal bayar karena penyaluran ini tercatat di luar buku akuntansi mereka."
        },
        {
            p: "Pada akhirnya bank harus tetap menjalankan fungsinya sebagai intermediary, menghimpun dana dari masyarakat surplus dan menyalurkan lagi ke masyarakat defisit (memerlukan pembiayaan dari bank)."
        },
        {
            p: "Salah satu bank yang DailySocial hubungi adalah BCA. EVP Secretariat & Corporate Communication BCA Hera F Haryn menjelaskan, skor kredit yang dipakai BCA masih menggunakan data-data yang terdapat di internal BCA, seperti data demografi debitur dan transaksi."
        },
        {
            p: '"Sedangkan untuk teknik pembuatan scoring menggunakan dua cara, yakni statistic logistic regression dan mulai menggunakan machine learning," katanya (14/11).'
        },
        {
            p: "Regresi logistik adalah salah satu model statistik populer yang digunakan untuk klasifikasi biner, prediksi jenis ini atau itu, ya atau tidak, A atau B, dan lain-lain. Dia juga dapat digunakan untuk klasifikasi multiclass."
        },
        {
            p: "BCA merealisasikan solusi LC Automize, bersama startup AI asal Singapura 6Estates, untuk mengotomasi dokumen manual dan pemeriksaan kepatuhan berdasarkan aturan internasional dan standar internasional saat analisis dokumen LC (letter of credit), dengan menggabungkan AI dan otomatisasi proses robotic untuk bisnis trade finance."
        },
        {
            p: "Cara tersebut diharapkan dapat mengurangi waktu penyelesaian untuk memroses setiap aplikasi yang masuk. BCA juga dapat mengembangkan bisnisnya secara eksponensial tanpa menghadapi masalah skalabilitas."
        },
        {
            p: "Ini masih tahap awal implementasi machine learning di dalam struktur bisnis BCA. Kemungkinan besar LC Automize akan diteruskan ke lini lainnya."
        },
        {
            h4: "Cara fintech membangun skor kredit"
        },
        {
            p: "Pada dasarnya, semua perusahaan, terlepas bergerak di fintech atau tidak, bisa mengumpulkan data nasabah, entah online atau offline, untuk dimanfaatkan kembali ke berbagai tujuan. Salah satunya, membangun sistem analisis kredit."
        },
        {
            p: "Pemahaman ini bisa menjadi bekal bahwa semua perusahaan punya kapabilitas untuk punya sistem skor kredit mandiri, asal memiliki teknologi dan expertise."
        },
        {
            p: "Cara awal Gojek atau Traveloka merilis produk keuangan, semacam PayLater, juga dimulai dari mengumpulkan data kebiasaan konsumen yang dipupuk perlahan-lahan sampai akhirnya bisa diutilisasi untuk dikembangkan lebih lanjut ke sektor keuangan."
        },
        {
            p: "Sementara startup fintech lending lebih banyak membangun skor kreditnya dengan data lain yang belum ada di biro kredit. Sebelum tersandung kasus, awalnya pemain bisa mengakses berbagai data di smartphone calon debitur."
        },
        {
            p: "Kini OJK membatasi data digital yang bisa diakses dari smartphone adalah kamera, mikrofon, dan lokasi. Ketiganya dianggap paling relevan dan diperlukan perusahaan fintech lending dalam mengenali calon nasabah."
        },
        {
            image:require('@/assets/idImage/newdetail/newfive4.jpg')
        },
        {
            p: "Bagi Tongdun, platform inovasi keuangan digital Tiongkok untuk skor kredit yang sudah terdaftar di OJK, tiga jenis data ini sebenarnya masih dianggap kurang untuk mendapatkan data mengenai kebiasaan nasabah. Bagi startup seperti mereka, poin intinya adalah ingin melihat secara holistik, dari berbagai sisi, lewat sebanyak mungkin data untuk menghasilkan analisis kredit yang akurat."
        },
        {
            p: "Oleh karena itu, perusahaan tengah berdiskusi dengan PLN, BPJS, Dukcapil, Ditjen Pajak, dan perusahaan telekomunikasi untuk mengutilisasi data mereka secara mendalam untuk kebutuhan analisis. Selama ini perbankan belum sepenuhnya memanfaatkan data-data dasar tersebut."
        },
        {
            p: "Director of Consulting and Solution Tongdun Suhardiman Agung menjelaskan, jejak digital di Indonesia belum tersebar secara merata, masih terpusat di kota besar saja. Dia mencontohkan, tagihan listrik PLN tergolong data dasar yang bisa memberikan gambaran tentang keuangan seseorang."
        },
        {
            p: "Dari situ juga bisa tergambar bagaimana memverifikasi alamat dengan melihat ID pelanggan PLN mereka, untuk memastikan mereka bukan penipu. Melihat seperti apa latar belakang ekonomi cukup dengan memerhatikan konsumsi listriknya. Misalnya nasabah berjualan dengan omzet sekian, maka konsumsi listriknya harus sesuai prediksi."
        },
        {
            p: '"Indonesia menarik karena ada banyak SME, ekonomi informalnya besar. Tapi tantangannya bagaimana kita bisa tahu warung kaki lima keuangannya bagus atau tidak. Caranya dengan memanfaatkan data offline untuk dianalisis dengan machine learning," terang Suhardiman kepada DailySocial (6/11).'
        },
        {
            image:require('@/assets/idImage/newdetail/newfive5.jpg')
        },
        {
            p: "Sementara ini Tongdun masih memanfaatkan data digital untuk membantu mitra dalam analisis risiko, tapi semuanya harus melalui perizinan nasabah. Nasabah juga harus sadar mereka memberikan akses data, entah itu dari akun Facebook atau akun e-commerce untuk memperoleh kredit."
        },
        {
            p: "Startup fintech yang niche, seperti Fineoz dan Tongdun, saling berlomba memberikan kecepatan analisis risiko dengan teknologi AI, machine learning, computing platforms, dan core technologies yang dikombinasi dengan API dan cloud computing."
        },
        {
            p: "Anis menjelaskan, tidak melulu punya banyak data itu selalu baik karena menurutnya kuantitas sangat jauh berbeda dengan kualitas. Semakin besar kuantitas data tidak menjamin semakin baik kualitas analisis dan keputusan kredit yang dihasilkan."
        },
        {
            p: '"Fineoz fokus meningkatkan kualitas keputusan kredit. Kami tidak menafikan pentingnya sumber data yang banyak. Akan tetapi dengan teknologi AI segala keterbatasan data bisa diatasi dengan lebih mudah."'
        },
        {
            p: "Fineoz sendiri sudah mengolah hampir 3,5 juta data nasabah melalui beberapa kerja sama strategis. Jenis data kredit sangat beragam, termasuk data kredit komersial (invoice financing, seller financing, merchant financing, dan lain-lain) dan kredit konsumsi (kredit motor, mobil, KTA, dan payday loan)."
        },
        {
            p: "Tak mau kalah, Pefindo Biro Kredit (PBK) mengumpulkan data kredit dari berbagai sumber. Mulai dari SID BI, SLIK OJK, lembaga keuangan yang menjadi anggota PBK, termasuk koperasi, fintech p2p lending, dan lembaga non keuangan seperti retailer."
        },
        {
            p: "Mereka juga ekerja sama dengan institusi lainnya untuk mengakses data non kredit, seperti BPJS Ketenagakerjaan, Taspen, identitas pajak, data pailit, wanprestasi dari putusan Mahkamah Agung, data emiten dari BEI, dan data peringkat perusahaan dari Pemeringkat Efek Indonesia."
        },
        {
            p: "Yohanes menyebut PBK tercatat memilki data kredit sebesar 91 juta data individu dan 500 ribu data perusahaan. Agar seluruh data ini bisa dimanfaatkan dengan sebaik-baiknya, perusahaan terus melakukan pengembangan atas akurasi data dan metodologi dari skoring kredit PBK."
        },
        {
            p: '"Selain itu kami berencana untuk mengembangkan alternatif skoring kredit untuk memenuhi masyarakat yang masih unbanked atau underserved. Di samping itu, tidak menutup kemungkinan mengembangkan AI."'
        },
        {
            h4:'Masa depan skor kredit di Indonesia'
        },
        {
            p: "Lembaga keuangan dan fintech tidak bisa selamanya berjalan sendiri-sendiri. Prudent-nya bank saat menyalurkan pinjaman dan dinamisnya fintech dalam mengolah data untuk analisis risiko menjadi perpaduan yang pas untuk menggarap nasabah unbanked dan unbankable."
        },
        {
            p: "Tak heran jika semakin banyak lembaga keuangan, termasuk layanan p2plending, bekerja sama dengan perusahaan sejenis Tongdun dan Fineoz untuk membantu mereka menganalisis nasabah potensial dari berbagai angle."
        },
        {
            image:require('@/assets/idImage/newdetail/newfive6.jpg')
        },
        {
            p: "Yang terbaru, Bank Permata menjadi lender institusi terbesar di Kredivo. Bank menyalurkan hingga Rp1 triliun untuk disalurkan kembali oleh perusahaan."
        },
        {
            p: "Keputusan bank menaruh dana sebesar itu pasti bukan keputusan mudah. Startup seperti Kredivo harus punya standarisasi sistem manajemen risiko yang setara dengan bank."
        },
        {
            p: "Pada Senin (2/12), Pefindo Biro Kredit berkolaborasi dengan Fineoz untuk mengembangkan informasi perkreditan berupa alternatif skoring melalui pemanfaatan data alternatif."
        },
        {
            p: '"Kita kolaborasi penggunaan data alternatif, supaya cakupan masyarakat unbanked untuk scoring kredit dan akses keuangan bisa lebih besar," tutur Anis.'
        },
        {
            p: "Asosiasi Fintech Pendanaan Bersama Indonesia (AFPI) juga merilis pusat data Fintech Data Center (FDC) untuk mempermudah pemain p2p melakukan penilaian kredit. Fungsinya sama dengan BI Checking dan SLIK dengan semangat menghindari potensi gagal bayar, penipuan, dan penyaluran kredit yang berlebihan."
        },
        {
            p: "FDC telah terhubung dengan BI Checking dan SLIK. Nantinya kemitraan ini akan bertambah dengan pihak lain, termasuk BPJS Kesehatan dan Ketenagakerjaan, asuransi, multifinance, perbankan, dan pasar modal."
        },
        {
            p: "Suhardiman menuturkan, kemampuan pemain fintech yang fokus pada analisis kredit tentunya punya nilai lebih. Investasi teknologi dan expertise yang harus digelontorkan bukanlah harga murah."
        },
        {
            p: '"Kami lebih seperti data aggregator, terkoneksi dengan berbagai sumber data. Terlebih itu, kita punya expertise khusus di bidang ini. Pemain fintech atau bank belum tentu punya exposure seperti kita," ujarnya.'
        },
        {
            p: "Saat ini layer pertama yang paling terbantu dengan kehadiran pemain skor kredit adalah perbankan. Layer berikutnya akan lintas industri. "
        },
        {
            p: "Suhardiman mencontohkan, di Tiongkok, utilisasi analisis kredit sangat advance. Di sana, data seperti ini dipakai perusahaan logistik untuk menganalisis status pengantaran dan profiling pengemudi."
        },
        {
            p: "Perusahaan asuransi di Tiongkok juga memanfaatkan skor kredit untuk pembayaran klaim sebagai tindakan mencegah potensi fraud."
        },
        {
            p: '"Teknologi yang kami bawa ke Indonesia dari Tiongkok masih sebagian kecil. Belum tentu semuanya bisa kami bawa karena menyesuaikan kebiasaan orang sini dan butuh personalisasi."'
        },
        {
            image:require('@/assets/idImage/newdetail/newfive7.jpg')
        },
        {
            p: "Hal ini bisa menjadi gambaran besar bahwa demand akan kebutuhan analisis kredit akan semakin tinggi di Indonesia."
        },
        {
            p: "Salah satu pemain baru yang siap tancap gas adalah CekAja. Awalnya CekAja adalah platform agregator produk finansial, kemudian mereka segera merambah bisnis skor kredit bernama CekSkor."
        },
        {
            p: "Produk yang akan dirilis pada awal tahun depan ini adalah realisasi akuisisi yang dilakukan CekAja terhadap id/x untuk membantu proses skor bersama Experian yang sudah berpengalangan di bidang yang sama. Experian adalah satu dari tiga perusahaan credit scoring terbesar di dunia, bersama Equifax dan Transunion."
        },
    ]
}